import { atom } from 'recoil';

export const SelectedCustomerState = atom<{ id: string | null }>({
  key: 'SelectedCustomerState',
  default: {
    id: null,
  },
});
